import React, { useContext } from "react";
import { UserIcon } from '@patternfly/react-icons';
import {
  Nav,
  NavList,
  NavItem,
  Button, Tooltip
} from "@patternfly/react-core";

import { Link, useLocation } from "react-router-dom";

import {
  UserDropdown,
} from "shared/components/User";

import {
  AuthContext,
  AppContext,
} from "shared/context";


const SchoolProfile = () => {

  const {
    state,
    logout,
  } = useContext(AuthContext);

  const {
    react_app_api_url,
    organizationSymbol
  } = useContext(AppContext).state;


  const {
    userProfile,
    systemInfo,
    isAuthUser,
    isLoadedUserProfile,
  } = state;

  const location = useLocation();

  if (!isAuthUser || !isLoadedUserProfile) {
    return (
      <Nav
        aria-label="Profile navigation"
        variant="horizontal"
      >
        <NavList>
          <NavItem>
            <Tooltip content="Zaloguj się">
              <Button
                component={(props) => (
                  <Link
                    {...props}
                    to={`/${organizationSymbol}/ti/auth`}
                    state={{
                        from: location.pathname + location.search,
                    }}
                  />
                )}
                variant="secondary"
                icon={<UserIcon />}
                aria-label="Zaloguj się"
              />
            </Tooltip>
          </NavItem>
        </NavList>
      </Nav>
    );
  }


  const items = [
    ...((userProfile.is_superuser || userProfile.is_staff)
      ? [
          {
            id: "admin",
            label: "Admin Panel",
            onClick: () =>
              window.open(
                `${react_app_api_url}/admin/`,
                "_blank"
              ),
          },
        ]
      : []),

    {
      id: "logout",
      label: "Wyloguj",
      onClick: logout,
    },
  ];

  return (
    <UserDropdown
      userProfile={userProfile}
      systemInfo={systemInfo}
      items={items}
    />
  );
};


export default SchoolProfile;